import type { RootState } from '@/app/types/store';
import { layoutApi } from '../api/layoutApi';

export const selectLayoutData = (state: RootState) => layoutApi.endpoints.initLayout.select()(state)?.data;

export const selectLayoutContext = (state: RootState) => selectLayoutData(state)?.context;

export const selectCurrentProject = (state: RootState) => selectLayoutContext(state)?.project;

export const selectCurrentSite = (state: RootState) => selectLayoutContext(state)?.site;

export const selectAvailableProjects = (state: RootState) => selectLayoutContext(state)?.projects || [];

export const selectAvailableSites = (state: RootState) => selectLayoutContext(state)?.sites || [];

export const selectLayoutUser = (state: RootState) => selectLayoutData(state)?.user;

export const selectLayoutMenu = (state: RootState) => selectLayoutData(state)?.menu;

export const selectMenuItems = (state: RootState) => selectLayoutMenu(state)?.items || [];

export const selectMenuBadges = (state: RootState) => selectLayoutMenu(state)?.badges;

export const selectUserPermissions = (state: RootState) => selectLayoutData(state)?.permissions;

export const selectBuildInfo = (state: RootState) => selectLayoutData(state)?.buildInfo;

export const selectAvailableLocales = (state: RootState) => selectLayoutData(state)?.locales || [];

export const selectInstanceInfo = (state: RootState) => selectLayoutData(state)?.instance;

export const selectIsReadOnly = (state: RootState) =>
  selectLayoutContext(state)?.readOnly || selectUserPermissions(state)?.readOnly || false;
